module.exports = __webpack_public_path__ + "img/ICPhome.48c7b1ee.svg";